const QUERY_KEY_ASSIGN_EMPLOYEE_ID = 'assignEmployeeId';
const QUERY_KEY_ASSIGN_RETURN_TO = 'assignReturnTo';

export type AssignProfileLocationState = {
    assignEmployeeId: string;
    /** Where the assignment step's back action should lead, when not the roster list. */
    returnTo?: string;
};

export const buildAssignProfileLocationState = ({
    employeeId,
    returnTo,
}: {
    employeeId: string;
    returnTo?: string;
}): AssignProfileLocationState => ({ assignEmployeeId: employeeId, returnTo });

export const buildAssignProfileSearch = (state: AssignProfileLocationState): string => {
    const searchParams = new URLSearchParams();
    searchParams.set(QUERY_KEY_ASSIGN_EMPLOYEE_ID, state.assignEmployeeId);

    if (state.returnTo) {
        searchParams.set(QUERY_KEY_ASSIGN_RETURN_TO, state.returnTo);
    }

    return `?${searchParams.toString()}`;
};

/**
 * Resolves the employee whose assignment flow should open on arrival. Router state is the
 * richest channel but the host drives navigation for its own routes, so the query string is
 * the only one guaranteed to survive; when embedded the router is in-memory and carries no
 * search either, hence the browser URL as last resort.
 */
export const resolveAssignProfileRequest = ({
    locationState,
    search,
}: {
    locationState?: AssignProfileLocationState;
    search: string;
}): AssignProfileLocationState | undefined => {
    if (locationState?.assignEmployeeId) {
        return locationState;
    }

    const fromRouter = new URLSearchParams(search);
    const fromBrowser = new URLSearchParams(window.location.search);
    const params = fromRouter.has(QUERY_KEY_ASSIGN_EMPLOYEE_ID) ? fromRouter : fromBrowser;

    const assignEmployeeId = params.get(QUERY_KEY_ASSIGN_EMPLOYEE_ID);
    if (!assignEmployeeId) {
        return undefined;
    }

    return {
        assignEmployeeId,
        returnTo: params.get(QUERY_KEY_ASSIGN_RETURN_TO) ?? undefined,
    };
};
